import React from "react";
import { graphql } from "gatsby";
import { motion } from "framer-motion";
import { PrismicRichText } from "@prismicio/react";
import ContactForm from "../../components/ContactForm";
import * as styles from "./contact.module.css";

export const Contact = ({ slice }) => {
  const { heading, copy, form_heading } = slice?.primary || {};

  return (
    <section
      data-color-scheme="paper"
      data-highlight-background="spice-red"
      data-highlight-foreground="white"
      data-tilt-scheme="right"
      id="contact"
    >
      <div className="section-split-6-5 page-width padding-section-vertical">
        <motion.div
          className={styles.content}
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
        >
          {heading && (
            <PrismicRichText
              field={heading.richText}
              components={{
                heading2: ({ children }) => <h2 className="h1">{children}</h2>,
              }}
            />
          )}
          {copy && <PrismicRichText field={copy.richText} />}
        </motion.div>
        <motion.div
          className={styles.form}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{
            duration: 0.7,
            delay: 0.15,
            ease: [0.25, 0.1, 0.25, 1],
          }}
        >
          <ContactForm heading={form_heading?.text} />
        </motion.div>
      </div>
    </section>
  );
};

export const query = graphql`
  fragment HomepageDataBodyContact on PrismicHomepageDataBodyContact {
    primary {
      heading {
        richText
      }
      copy {
        richText
      }
      form_heading {
        text
      }
    }
  }
`;
